import {useAccountDm, useGroupListDm, usePortfolioDm, usePropertyDm} from "../../../../../__snowpack__/link/packages/dm/dist/dm.esm.js";
import {useCallback, useEffect, useState} from "react";
export function usePropertiesFilters(jwt, formRef) {
  const {
    getAccountsAsFilter
  } = useAccountDm(jwt);
  const {
    getPortfoliosAsFilter
  } = usePortfolioDm(jwt);
  const {
    getPropertiesAsFilter
  } = usePropertyDm(jwt);
  const {
    getGroupsAsFilter
  } = useGroupListDm(jwt);
  const [open, setOpen] = useState({});
  const [loading, setLoading] = useState({});
  const [refetchField, setRefetchField] = useState([]);
  const [propertyList, setPropertyList] = useState();
  const [groupList, setGroupList] = useState();
  const [accountList, setAccountList] = useState();
  const [portfolioList, setPortfolioList] = useState();
  const account = formRef?.current?.values.account;
  const group = formRef?.current?.values.group;
  const portfolio = formRef?.current?.values.portfolio;
  const onOpenAutocomplete = useCallback((field) => {
    setOpen({
      [field]: true
    });
  }, []);
  const onCloseAutocomplete = useCallback((field) => {
    setOpen({
      [field]: false
    });
  }, []);
  const onRefetchField = useCallback((field) => {
    setRefetchField(field);
  }, []);
  useEffect(() => {
    if (open?.account && !accountList && !loading?.account || open.account && refetchField.includes("account") && !loading?.account) {
      !loading?.account && setLoading((prevState) => ({
        ...prevState,
        account: true
      }));
      getAccountsAsFilter().then((response) => {
        setAccountList(response.results.map((result) => {
          return {
            id: result.id,
            label: result.name
          };
        }));
        refetchField && setRefetchField([]);
        return setLoading({
          account: false
        });
      });
    }
  }, [accountList, getAccountsAsFilter, loading?.account, open?.account, refetchField]);
  useEffect(() => {
    if (open?.portfolio && !portfolioList && !loading?.portfolio || open.portfolio && refetchField.includes("portfolio") && !loading?.portfolio) {
      !loading?.portfolio && setLoading((prevState) => ({
        ...prevState,
        portfolio: true
      }));
      getPortfoliosAsFilter({
        account
      }).then((response) => {
        setPortfolioList(response.results.map((result) => {
          return {
            id: result.id,
            label: result.name
          };
        }));
        refetchField && setRefetchField([]);
        return setLoading((prevState) => ({
          ...prevState,
          portfolio: false
        }));
      });
    }
  }, [account, getPortfoliosAsFilter, group, loading?.portfolio, open?.portfolio, portfolioList, refetchField]);
  useEffect(() => {
    if (open?.group && !groupList && !loading?.group || open.group && refetchField.includes("group") && !loading?.group) {
      !loading?.group && setLoading((prevState) => ({
        ...prevState,
        group: true
      }));
      getGroupsAsFilter({
        account,
        portfolio
      }).then((response) => {
        setGroupList(response.results.map((result) => {
          return {
            id: result.id,
            label: result.name
          };
        }));
      }).then(() => {
        refetchField && setRefetchField([]);
        return setLoading((prevState) => ({
          ...prevState,
          group: false
        }));
      });
    }
  }, [account, getGroupsAsFilter, groupList, loading?.group, open?.group, portfolio, refetchField]);
  useEffect(() => {
    if (open?.property && !propertyList && !loading?.property || open.property && refetchField.includes("property") && !loading?.property) {
      !loading?.property && setLoading((prevState) => ({
        ...prevState,
        property: true
      }));
      getPropertiesAsFilter({
        account,
        group,
        portfolio__id: portfolio
      }).then((response) => {
        setPropertyList(response.results.map((result) => {
          return {
            id: result.id,
            label: result.name
          };
        }));
        refetchField && setRefetchField([]);
        return setLoading((prevState) => ({
          ...prevState,
          property: false
        }));
      });
    }
  }, [account, propertyList, getPropertiesAsFilter, group, loading?.property, open?.property, portfolio, refetchField]);
  return {
    open,
    loading,
    propertyList,
    groupList,
    accountList,
    portfolioList,
    onOpenAutocomplete,
    onCloseAutocomplete,
    onRefetchField
  };
}
